jQuery(document).ready(() => {
  function sync(e) {
    e.preventDefault();

    let el = e.target || e.srcElement;
    let form = jQuery(el).parent('form');
    let unindexed_array = form.serializeArray();

    let indexed_array = {};
    jQuery.map(unindexed_array, function (n, i) {
      indexed_array[n['name']] = n['value'];
    });

    let xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (xhr.readyState == XMLHttpRequest.DONE) {
        location.reload();
      }
    };
    xhr.open('POST', form.attr('action'), true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(indexed_array));
  }
});
